module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_itau.cd4a1a8d.svg";